import type { StatusMap } from '@/config/statusMaps';

export interface StatusIndicatorProps<K extends string> {
  /**
   * Raw status value from the API (unknown values render with a fallback)
   */
  status: string | null | undefined;
  /**
   * Status map that turns the value into a label and class
   */
  map: StatusMap<K>;
  /**
   * Base class; the dot gets `${baseClassName}-dot`, e.g. "certs-status"
   */
  baseClassName: string;
}

/**
 * Dot + label status pill used by all tables
 */
export function StatusIndicator<K extends string>({ status, map, baseClassName }: StatusIndicatorProps<K>) {
  const config = map.get(status);

  return (
    <span className={`${baseClassName} ${config.className}`.trim()}>
      <span className={`${baseClassName}-dot`} />
      {config.label}
    </span>
  );
}
